import React from "react"
import { Card, Typography, TextField, Autocomplete } from "@mui/material"

const CustomMultiAutoSelect = React.forwardRef(
  (
    {
      label = "Select Options",
      options = [],
      defaultValue = [],
      value,
      getOptionLabel = (option) => option.name,
      onChange,
      error = false,
      helperText = "",
      loading = false,
    },
    ref
  ) => {
    return (
      <Autocomplete
        multiple
        options={options}
        loading={loading}
        getOptionLabel={getOptionLabel}
        value={value !== undefined ? value : defaultValue}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={error}
            helperText={helperText}
            inputRef={ref}
          />
        )}
        sx={{ width: "100%" }}
      />
    )
  }
)

export default CustomMultiAutoSelect
